/**
 * Equal Housing Opportunity / Equal Housing Lender badges.
 * Standard HUD-style icon: house silhouette in a square with bold caption.
 *
 * variant:
 *  - "opportunity" (default): "Equal Housing Opportunity" — for real-estate brokers
 *  - "lender": "Equal Housing Lender" — for mortgage lenders
 */
export default function EhoBadge({
  variant = "opportunity",
  size = 56,
  color = "#0A0A0A",
  textColor,
  className = "",
}) {
  const labelTop = variant === "lender" ? "EQUAL HOUSING" : "EQUAL HOUSING";
  const labelBottom = variant === "lender" ? "LENDER" : "OPPORTUNITY";
  const text = textColor || color;

  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      aria-label={`${labelTop} ${labelBottom}`}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
      >
        <rect
          x="2"
          y="2"
          width="60"
          height="60"
          fill="none"
          stroke={color}
          strokeWidth="3"
        />
        {/* House silhouette */}
        <path
          d="M32 13 L52 30 L46 30 L46 49 L37 49 L37 38 L27 38 L27 49 L18 49 L18 30 L12 30 Z"
          fill={color}
        />
      </svg>
      <div className="leading-tight" style={{ color: text }}>
        <div className="text-[9px] uppercase tracking-[0.18em] font-semibold">
          {labelTop}
        </div>
        <div className="text-[9px] uppercase tracking-[0.18em] font-semibold">
          {labelBottom}
        </div>
      </div>
    </div>
  );
}
